module.exports = __webpack_public_path__ + "img/pr-11.dfd2493c.png";